import React from "react";
import { getImgPath } from "../common/helper";
import {
  t,
  HEADING1,
  HEADING2,
  P1,
  HEADING3,
  UL1_LI1,
  UL1_LI2,
  UL1_LI3,
  UL1_LI4,
  UL1_LI5,
  UL1_LI6,
  UL1_LI7,
  UL1_LI8,
  UL2_LI1,
  UL2_LI2,
  UL2_LI3,
  HEADING4,
  P2,
  HEADING5,
  UL3_LI1,
  UL3_LI2,
  UL3_LI3,
  UL3_LI4,
  UL3_LI5,
  UL3_LI6,
  UL3_LI7,
  UL3_LI8,
  UL3_LI9,
  HEADING6,
  P3,
  HEADING7,
  P4,
  HEADING8,
  P5,
  HEADING9,
  P6,
} from "../../translations/AboutUs/ItInKsrtc";

function ItInKsrtc() {
  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div
        className="a-large"
        style={{ fontWeight: 600, textAlign: "left" }}>
        {t(HEADING1)}
      </div>
      <div className="a-normal"
        style={{ fontWeight: 500, textAlign: "left" }}>
        {t(HEADING2)}
      </div>
      <div
        className="a-regular"
        style={{
          fontWeight: 400,
          color: "#444444",
          textAlign: "justify",
          paddingBottom: 15,
        }}
      >
        {t(P1)}
      </div>
      <div className="a-normal"
        style={{ fontWeight: 500, textAlign: "left" }}>
        {t(HEADING3)}
      </div>
      <ul style={{ margin: 0, padding: 0, paddingLeft: 30 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL1_LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL1_LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL1_LI3)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL1_LI4)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL1_LI5)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL1_LI6)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL1_LI7)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL1_LI8)}</li>
      </ul>
      <div
        className="a-normal"
        style={{ fontWeight: 500, textAlign: "left" }}>
        {t(HEADING3)}
      </div>
      <ul style={{ margin: 0, padding: 0, paddingLeft: 30 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL2_LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL2_LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL2_LI3)}</li>
      </ul>
      <div style={{ fontSize: 16, fontWeight: 500, textAlign: "left" }}>
        {t(HEADING4)}
      </div>
      <div style={{ display: "flex", gap: 40 }}>
        <div
          className="a-regular"
          style={{
            fontWeight: 400,
            color: "#444444",
            textAlign: "justify",
            paddingBottom: 15,
            width: "60%",
          }}
        >
          {t(P2)}
        </div>
        <img src={getImgPath("/img/aboutus/Ticketing-Machines 1.png")} alt="" />
      </div>
      <div className="a-normal" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(HEADING5)}
      </div>
      <ul style={{ margin: 0, padding: 0, paddingLeft: 30 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL3_LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL3_LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL3_LI3)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL3_LI4)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL3_LI5)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL3_LI6)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL3_LI7)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL3_LI8)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(UL3_LI9)}</li>
        <div
          className="a-normal"
          style={{
            fontWeight: 500,
            textAlign: "left",
            paddingTop: 15,
          }}
        >
          {t(HEADING6)}
        </div>
        <div style={{ display: "flex", gap: 40 }}>
          <div
            className="a-regular"
            style={{
              fontWeight: 400,
              color: "#444444",
              textAlign: "justify",
              paddingBottom: 15,
              width: "60%",
            }}
          >
            {t(P3)}
          </div>
          <img
            src={getImgPath("/img/aboutus/Ticketing-Machines-1 1.png")}
            alt=""
          />
        </div>
        <div className="a-normal" style={{ fontWeight: 500, textAlign: "left" }}>
          {t(HEADING7)}
        </div>
        <div style={{ display: "flex", gap: 40 }}>
          <div
            className="a-regular"
            style={{
              fontWeight: 400,
              color: "#444444",
              textAlign: "justify",
              paddingBottom: 15,
              width: "60%",
            }}
          >
            {t(P4)}
          </div>
        </div>
        <div className="a-normal" style={{ fontWeight: 500, textAlign: "left" }}>
          {t(HEADING8)}
        </div>
        <div style={{ display: "flex", gap: 40 }}>
          <div
            className="a-regular"
            style={{
              fontWeight: 400,
              color: "#444444",
              textAlign: "justify",
              paddingBottom: 15,
              width: "60%",
            }}
          >
            {t(P5)}
          </div>
          <img
            src={getImgPath("/img/aboutus/Ticketing-Machines-2 1.png")}
            alt=""
          />
        </div>
        <div className="a-normal" style={{ fontWeight: 500, textAlign: "left" }}>
          {t(HEADING9)}
        </div>
        <div style={{ display: "flex", gap: 40 }}>
          <div
            className="a-regular"
            style={{
              fontWeight: 400,
              color: "#444444",
              textAlign: "justify",
              paddingBottom: 15,
              width: "60%",
            }}
          >
            {t(P6)}
          </div>
        </div>
      </ul>
    </div>
  );
}

export default ItInKsrtc;
